import React from 'react';

interface CustomIconProps {
  filled?: boolean;
  color?: string;
}

const TimerClockIcon: React.FC<CustomIconProps> = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20.145 8.26997L21.708 6.70697L20.294 5.29297L18.586 6.99997C17.536 6.36997 16.312 5.99997 15 5.99997C11.141 5.99997 8 9.13997 8 13C8 16.86 11.141 20 15 20C18.859 20 22 16.86 22 13C21.9992 11.246 21.3368 9.55687 20.145 8.26997ZM15 18C12.243 18 10 15.757 10 13C10 10.243 12.243 7.99997 15 7.99997C17.757 7.99997 20 10.243 20 13C20 15.757 17.757 18 15 18Z'
      fill='#EF4444'
    />
    <path
      d='M14 10H16V14H14V10ZM13 3H17V5H13V3ZM3 8H7V10H3V8ZM3 16H7V18H3V16ZM2 12H5.99V14H2V12Z'
      fill='#EF4444'
    />
  </svg>
);

export default TimerClockIcon;
